import { service ,BASE_API } from '@/utils/request'
const v2 = BASE_API
export default{
    //查询资料分页
    getCourseMaterialList:function getCourseMaterialList(data){
        return  service({
            url:"/cloud/course/v1/admin/courseMaterial/search",
            method:'post',
            data:data
        })
    },

    //添加资料
    addMaterialData:function addMaterialData(data){
        return service({
            url:"/cloud/course/v1/admin/courseMaterial/add",
            method:'post',
            data:data
        })
    },

     //编辑资料
     editMaterialData:function editMaterialData(data){
        return service({
            url:'/cloud/course/v1/admin/courseMaterial/update',
            method:'post',
            data:data
        })
     },
     //资料删除
     deleteMaterialData:function deleteMaterialData(id){
        return service({
            url:`/cloud/course/v1/admin/courseMaterial/delete/${id}`,
            method:'post',
          
        })
     },
     //修改资料权重或者状态
     updateByCondition:function updateByCondition(data){
        return service({
            url:'/cloud/course/v1/admin/courseMaterial/updateByCondition',
            method:'post',
            data:data
        })
     },

     //关联课程源分页列表
     getSourceList:function getSourceList(data){
      return service({
        url:'/cloud/course/v1/admin/courseMaterial/bindCourseSource/search',
        method:'post',
        data:data
      })
     },

//绑定课程源和资料的关系
bindMaterial:function bindMaterial(data){
  return  service({
    url:"/cloud/course/v1/admin/courseSourceCourseMaterial/add",
    method:'post',
    data:data
  })
},
//解除解除绑定-软删除
disassociate:function disassociate(data){
    return service({
        url:'/cloud/course/v1/admin/courseSourceCourseMaterial/delete',
        method:'post',
        data:data
    })
},
//资料下载记录分页列表
getDownList: function getDownList(data){
    return service({
        url:"/cloud/course/v1/admin/courseMaterialDownloadRecord/search",
        method:'post',
        data:data
    })
},
//导出下载列表
 exportExcel(params) {
   return service({
    url:'/cloud/course/v1/admin/courseMaterialDownloadRecord/exportExcel',
    method:'get',
    params,
    responseType: 'blob'
   })
}, 

}


// WEBPACK FOOTER //
// ./src/api/contentManage/materialmanage.js